module.exports = __webpack_public_path__ + "29d2ed8d0d9cca83da2629bb690be536.svg";